<template>
  <a @click="$emit('click')">
    <Card shadow class="card-button base-simple-card">
      <p class="card-simple-button-text">{{text}}</p>
    </Card>
  </a>
</template>

<script>
import "./card-simple-button.less";
export default {
  name: "card-simple-button",
  props: {
    text: String
  },
  methods: {}
};
</script>
